// frontend/src/services/api/fusio.js

import { postgrestClient } from "./postgrest";

const POSTGREST_EQUALS_OPERATOR = "eq.";

const buildCarFilter = (numeroCar) =>
  `${POSTGREST_EQUALS_OPERATOR}${encodeURIComponent(numeroCar ?? "")}`;

const buildQueryUrl = (resource, numeroCar) =>
  `${resource}?cod_imovel=${buildCarFilter(numeroCar)}`;

export const getDadosImovel = (numeroCar) => {
  return postgrestClient.get(
    buildQueryUrl("/imovel_area_imovel", numeroCar)
  );
};

export const getDadosCartograma = (numeroCar) => {
  const url = buildQueryUrl("/declividade", numeroCar);
  console.error("[fusio] GET", url);
  return postgrestClient.get(url);
};

export const getDadosSerieHistoria = (numeroCar) => {
  return postgrestClient.get(
    buildQueryUrl("/cartograma_uso_cobertura_solo_serie", numeroCar)
  );
};

export const getDadosTabelaHistoricoUsoSolo = (numeroCar) => {
  return postgrestClient.get(
    buildQueryUrl("/tabela_historico_uso_solo", numeroCar)
  );
};

export const getDadosTabelaSintese = (numeroCar) => {
  return postgrestClient.get(
    buildQueryUrl("/tabela_sintese", numeroCar)
  );
};

export const getDadosTabelaSintese2008 = (numeroCar) => {
  return postgrestClient.get(
    buildQueryUrl("/tabela_sintese2008", numeroCar)
  );
};
